import {httpPost} from '@/shared/api/serve/httpPost';

import {EventItem} from '../types';

export async function sendEvents(
  payload: EventItem[],
  {uuid}: {uuid?: string}
) {
  const params = new URLSearchParams();

  if (uuid) {
    params.set('uuid', uuid);
  }

  await httpPost(`events?${params}`, {
    events: payload,
  });
}
